import { Link } from "react-router";
import { Apple, Monitor, Download } from "lucide-react";
import { isDesktop } from "../lib/desktop";
import { useDesktopLatest } from "../lib/useDesktopLatest";

/**
 * Compact, OS-aware desktop-download link for the marketing hero. On macOS it
 * points straight at the signed `.dmg`; on every other platform it routes to
 * the full `/download` page. Hidden when already running inside the desktop
 * shell (where a download link is meaningless).
 */
export function HeroDownloadLink() {
  const { os, latest, macHref } = useDesktopLatest();
  if (isDesktop) return null;

  const onMac = os === "mac";
  const Icon = onMac ? Apple : os === "windows" ? Monitor : Download;
  const label = onMac
    ? "Download the macOS desktop app"
    : os === "windows"
      ? "Get the desktop app for Windows"
      : "Get the Pollenate desktop app";
  const href = onMac && macHref ? macHref : "/download";
  const isExternal = href.startsWith("http");

  const content = (
    <>
      <Icon className="h-4 w-4 text-primary" aria-hidden="true" />
      <span>{label}</span>
      {latest?.version ? (
        <span className="text-slate-400 dark:text-neutral-500">
          · {latest.version}
        </span>
      ) : null}
    </>
  );

  const className =
    "inline-flex items-center gap-2 rounded-full border border-primary-300 dark:border-primary-500 bg-primary/5 px-4 py-2 text-sm font-medium text-slate-600 dark:text-neutral-300 transition-colors hover:bg-primary/10";

  return (
    <div className="mt-8 flex justify-center">
      {isExternal ? (
        <a href={href} className={className}>
          {content}
        </a>
      ) : (
        <Link to={href} className={className}>
          {content}
        </Link>
      )}
    </div>
  );
}
